<template>
  <div>
    <div ref="editor" :class="{ 'quill-disabled': disabled }"></div>
  </div>
</template>

<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
  name: 'VueEditor',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    editorToolbar: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Enter text...',
    },
  },
  emits: ['update:modelValue', 'text-change', 'blur'],
  data() {
    return {
      quill: null,
      isUpdating: false,
    };
  },
  watch: {
    modelValue(newVal) {
      if (this.quill && !this.isUpdating) {
        const currentContent = this.quill.root.innerHTML;
        if (newVal !== currentContent) {
          const selection = this.quill.getSelection();
          this.quill.root.innerHTML = newVal || '';
          if (selection) {
            this.$nextTick(() => {
              this.quill.setSelection(selection);
            });
          }
        }
      }
    },
    disabled(newVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    },
  },
  mounted() {
    this.initializeQuill();
  },
  beforeUnmount() {
    if (this.quill) {
      this.quill = null;
    }
  },
  methods: {
    initializeQuill() {
      if (!this.$refs.editor) return;

      const toolbarConfig = this.editorToolbar && this.editorToolbar.length > 0
        ? this.editorToolbar
        : [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
            ['link'],
          ];

      this.quill = new Quill(this.$refs.editor, {
        theme: 'snow',
        placeholder: this.placeholder,
        readOnly: this.disabled,
        modules: {
          toolbar: toolbarConfig,
        },
      });

      // Set initial content
      if (this.modelValue) {
        this.quill.root.innerHTML = this.modelValue;
      }

      // Listen to text changes
      this.quill.on('text-change', (delta, oldDelta, source) => {
        this.isUpdating = true;
        const html = this.quill.root.innerHTML;
        
        this.$emit('update:modelValue', html);
        this.$emit('text-change', html, delta, oldDelta, source);
        
        this.$nextTick(() => {
          this.isUpdating = false;
        });
      });

      // Listen to blur events
      this.quill.root.addEventListener('blur', () => {
        this.$emit('blur');
      });

      // Enable/disable based on prop
      this.quill.enable(!this.disabled);
    },
  },
};
</script>

<style>
.quill-disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Left align toolbar content */
.ql-toolbar {
  text-align: left;
}

/* Set default height to approximately 10 lines */
.ql-container {
  min-height: 250px;
}

.ql-editor {
  min-height: 250px;
}
</style>
